import { SpanStatusCode } from '@opentelemetry/api'
import type { ReadableSpan, SpanProcessor } from '@opentelemetry/sdk-trace-web'

const HTTP_CLIENT_SCOPES = ['@opentelemetry/instrumentation-xml-http-request', '@opentelemetry/instrumentation-fetch']

function isHttpClientSpan(span: ReadableSpan): boolean {
  return HTTP_CLIENT_SCOPES.includes(span.instrumentationScope.name)
}

function isFailedSpan(span: ReadableSpan): boolean {
  if (span.status.code === SpanStatusCode.ERROR) return true
  const status = span.attributes['http.response.status_code'] ?? span.attributes['http.status_code']
  return typeof status === 'number' && status >= 400
}

/**
 * Wraps a span processor and drops XHR/fetch client spans that succeeded.
 * The spans are still created, so `traceparent`/`baggage` reach the backend, but only failed calls are exported.
 */
export class FailedHttpSpanProcessor implements SpanProcessor {
  constructor(private readonly inner: SpanProcessor) {}

  onStart(...args: Parameters<SpanProcessor['onStart']>): void {
    this.inner.onStart(...args)
  }

  onEnd(span: ReadableSpan): void {
    if (isHttpClientSpan(span) && !isFailedSpan(span)) return
    this.inner.onEnd(span)
  }

  forceFlush(): Promise<void> {
    return this.inner.forceFlush()
  }

  shutdown(): Promise<void> {
    return this.inner.shutdown()
  }
}
